import { useLocation } from "wouter";
import "../styles/default-page.css";
import { ExternalLink } from "../data/pageData";
import { useState } from "react";

export function DefaultProjectPage({ project }: { project: any }) {
    const defaultDescription: string =
        "Someone forgot to write a description for this...";

    const cssVariables: React.CSSProperties = {
        "--bg-image": `url(/images/${project.image})`,
        "--border-color": project.borderColor ? project.borderColor : "white",
    } as React.CSSProperties;

    const [isExiting, setIsExiting] = useState(false);
    const navigate = useLocation()[1];

    const handleExit = (id: string) => {
        setIsExiting(true);

        // wait for animation on page to finish
        setTimeout(() => {
            navigate(`/projects/${id}`);
        }, 300);
    };

    return (
        <div className="page-container">
            <div
                className={`info-container zoom-in ${isExiting ? "zoom-out" : "zoom-in"}`}
                style={cssVariables}
            >
                <div className="header-container">
                    <h1 className="unselectable-text">{project.title}</h1>
                    {project.tags && project.tags.length && (
                        <h1 className="unselectable-text tags-text">
                            {(project.tags as string[]).join(", ")}
                        </h1>
                    )}
                    <h1 className="unselectable-text date-text">
                        {project.date}
                    </h1>
                </div>
                <p
                    className="unselectable-text"
                    dangerouslySetInnerHTML={{
                        __html: project.description
                            ? project.description
                            : defaultDescription,
                    }}
                />
                <div className="button-container">
                    <button onClick={() => handleExit(project.id)}>
                        <p>← back to map</p>
                    </button>
                    <div className="links-container">
                        {project.links.map((externalLink: ExternalLink) => (
                            <a href={externalLink.url} target="_blank">
                                <button>
                                    <p>{externalLink.text.trim()}</p>
                                </button>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
